export default function fetchGraphQL(
  operationsDoc: string,
  operationName: string,
  userId: string,
  ean: string = null,
  variables: Record<string, any> = {}
) {
  return fetch(process.env.REACT_APP_HASURA_GRAPHQL_URL, {
    method: "POST",
    headers: {
      "x-hasura-user-id": userId,
      "x-hasura-farm-name": ean ?? sessionStorage.getItem("farm_name"),
      "Content-Type": "application/json",
    },
    mode: "cors",
    body: JSON.stringify({
      query: operationsDoc,
      variables,
      operationName,
    }),
    redirect: "follow",
  }).then((result) => result.json());
}
